module.exports = __webpack_public_path__ + "img/founder.4a439c16.jpg";